module.exports = __webpack_public_path__ + "static/img/make-bracelet-title-bg.bf788250.png";